const d = [
    {
        type: 'Feature',
        properties: {
            unique_id: '410324110',
            ext_path: '河南省 洛阳市 栾川县 白土镇',
            cid: '1',
            pid: '410324',
            name: '白土镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [111.413914, 34.04789]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410324002',
            ext_path: '河南省 洛阳市 栾川县 城关镇',
            cid: '2',
            pid: '410324',
            name: '城关镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [111.605996, 33.757353]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410324101',
            ext_path: '河南省 洛阳市 栾川县 赤土店镇',
            cid: '3',
            pid: '410324',
            name: '赤土店镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [111.589037, 33.880808]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410324102',
            ext_path: '河南省 洛阳市 栾川县 合峪镇',
            cid: '4',
            pid: '410324',
            name: '合峪镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [111.90147, 33.862977]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410324111',
            ext_path: '河南省 洛阳市 栾川县 叫河镇',
            cid: '5',
            pid: '410324',
            name: '叫河镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [111.295804, 33.848847]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410324105',
            ext_path: '河南省 洛阳市 栾川县 冷水镇',
            cid: '6',
            pid: '410324',
            name: '冷水镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [111.456629, 33.935912]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410324200',
            ext_path: '河南省 洛阳市 栾川县 栾川乡',
            cid: '7',
            pid: '410324',
            name: '栾川乡',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [111.638477, 33.771829]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410324108',
            ext_path: '河南省 洛阳市 栾川县 庙子镇',
            cid: '8',
            pid: '410324',
            name: '庙子镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [111.761758, 33.787391]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410324203',
            ext_path: '河南省 洛阳市 栾川县 秋扒乡',
            cid: '9',
            pid: '410324',
            name: '秋扒乡',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [111.637717, 34.047687]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410324104',
            ext_path: '河南省 洛阳市 栾川县 三川镇',
            cid: '10',
            pid: '410324',
            name: '三川镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [111.368154, 33.9382]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410324109',
            ext_path: '河南省 洛阳市 栾川县 狮子庙镇',
            cid: '11',
            pid: '410324',
            name: '狮子庙镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [111.539642, 34.034894]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410324107',
            ext_path: '河南省 洛阳市 栾川县 石庙镇',
            cid: '12',
            pid: '410324',
            name: '石庙镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [111.518891, 33.797371]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410324103',
            ext_path: '河南省 洛阳市 栾川县 潭头镇',
            cid: '13',
            pid: '410324',
            name: '潭头镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [111.725438, 34.0238]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410324106',
            ext_path: '河南省 洛阳市 栾川县 陶湾镇',
            cid: '14',
            pid: '410324',
            name: '陶湾镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [111.429025, 33.830542]
        }
    }
];

export { d };
